import type { AppState } from "../types";
import { Dialog } from "./Dialog";
import { Icon } from "./Icon";

export interface SyncConflict {
  state: AppState;
  revision: number;
  updatedAt: string | null;
}

export function SyncConflictDialog({ conflict, onUseCloud, onKeepDevice }: {
  conflict: SyncConflict | null;
  onUseCloud: () => void;
  onKeepDevice: () => void;
}) {
  return (
    <Dialog
      open={Boolean(conflict)}
      title="Choose the trip data to keep"
      description="This browser and your CodePawl account both contain Roam data. Nothing is overwritten until you choose."
      onClose={() => undefined}
      className="dialog-small sync-dialog"
    >
      <div className="sync-choices">
        <button type="button" onClick={onUseCloud}>
          <Icon name="cloud" size={22} />
          <span><strong>Use account data</strong><small>{conflict?.state.trips.length ?? 0} trips · Updated {conflict?.updatedAt ? new Date(conflict.updatedAt).toLocaleString() : "on another device"}</small></span>
        </button>
        <button type="button" onClick={onKeepDevice}>
          <Icon name="map" size={22} />
          <span><strong>Keep this browser</strong><small>Upload the trips currently visible here.</small></span>
        </button>
      </div>
    </Dialog>
  );
}
